
export class EnderecoSchemaCadastroModel {

  constructor(
    public cdCentrus?: number,
    public cdCentrusAlt?: number,
    public cdCep?: string,
    public cdCidade?: number,
    public cdPais?: number,
    public dhAlteracao?: string,
    public enCompl?: string,
    public enNumero?: string,
    public enPessoa?: string,
    public irEnderecoPessoa?: string,
    public noBairro?: string,
    public sgUf?: string,
    public cdContato?: string,
    public nrRamalFone1?: number
    ) {
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/endereco-schema-cadastro.model.ts